import { Text, useClassnames } from '@wb-tech/ui-react';
import { useTranslation } from 'react-i18next';
import React, { ReactNode, useState } from 'react';

import style from './index.module.pcss';

interface IExtraMessageProps {
    titleContent?: ReactNode,
    mainContent?: ReactNode,
    hiddenContent?: ReactNode
}

export const ExtraMessage = (props: IExtraMessageProps) => {
    const cn = useClassnames(style);
    const { t } = useTranslation();
    const [isShowHiddenInfoButton, setIsShowHiddenInfoButton] = useState<boolean>(true);

    return (
        <div className={cn('notification-message__container')}>
            {props.titleContent && (
                <Text className={cn('notification-message_bold')}>
                    {props.titleContent}
                </Text>
            )}

            {props.mainContent && (
                <Text className={cn('notification-message')}>
                    {props.mainContent}
                </Text>
            )}

            {props.hiddenContent && isShowHiddenInfoButton && (
                <button
                    type="button"
                    className={cn('notification-message__button')}
                    onClick={() => setIsShowHiddenInfoButton(false)}
                >
                    <Text
                        presetColor="link"
                        className={cn('notification-message__button-text')}
                    >
                        {t('components.notification.more-details')}
                    </Text>
                </button>
            )}
            {props.hiddenContent && !isShowHiddenInfoButton && (
                <Text className={cn('notification-message')}>
                    {props.hiddenContent}
                </Text>
            )}
        </div>
    );
};
